export default {
  SET_ORDERS: "SET_ORDERS",
  SET_SELECTED_ORDER: "SET_SELECTED_ORDER",
  ADD_ORDER: "ADD_ORDER",
  ADD_PENDING_PAYMENT: "ADD_PENDING_PAYMENT",
  REMOVE_PENDING_PAYMENT: "REMOVE_PENDING_PAYMENT",
  ORDER_CANCELED: "ORDER_CANCELED",
};
